<template>
  <div>
    <RightTitle title="积分记录"></RightTitle>

    <!-- 数据表格 -->
    <div class="uar_form">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column label="类型" prop="type"></el-table-column>
        <el-table-column label="变化积分" prop="value" width="100"></el-table-column>
        <el-table-column label="剩余积分" prop="remainValue" width="100"></el-table-column>
        <el-table-column label="时间" prop="addTime" width="160"></el-table-column>
        <el-table-column label="详情" width="80" align="center">
          <template slot-scope="scope">
            <el-popover placement="left" width="250" trigger="hover">
              <div v-html="scope.row.content"></div>
              <el-button slot="reference" type="text" size="small">详情</el-button>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <div class="uar_form page_area">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="dataTotal"
        @current-change="currentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
// 加载组件
import RightTitle from "../../components/RightTitle";
// 加载api
import { integrallog } from "../../api/user";
export default {
  name: "integrallog",
  components: {
    RightTitle
  },
  beforeRouteEnter(to, from, next) {
    integrallog(to.query).then(res => {
      next(vm => {
        vm.tableData = res.data.list;
        vm.dataTotal = res.data.count;
      });
    });
  },

  beforeRouteUpdate(to, from, next) {
    integrallog(to.query).then(res => {
      this.tableData = res.data.list;
      this.dataTotal = res.data.count;
    });
    next();
  },
  data() {
    return {
      tableData: [],
      dataTotal: 0,
      dialogContent: "",
      dialogVisible: false
    };
  },
  methods: {
    // 改变当前页
    currentChange(page) {
      this.$router.push({ query: { ...this.$route.query, page } });
    }
  }
};
</script>

<style scoped>
</style>